import type { SVGProps } from 'react';

interface DashboardIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function DashboardIcon({ className, ...props }: DashboardIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.75 4.75 14.5 14.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M12 5.75C12.2095 5.75 12.4095 5.82992 12.5586 5.96973L17.5186 10.6182C17.7502 10.8354 17.9341 11.0964 18.0596 11.3848C18.185 11.6732 18.25 11.9837 18.25 12.2969V17.4648C18.25 17.6698 18.1676 17.8686 18.0176 18.0166C17.8672 18.1649 17.6612 18.25 17.4443 18.25H6.55566C6.33885 18.25 6.13275 18.1649 5.98242 18.0166C5.83243 17.8686 5.75 17.6698 5.75 17.4648V12.2969C5.75002 11.9837 5.81496 11.6732 5.94043 11.3848C6.06593 11.0964 6.24978 10.8354 6.48145 10.6182L11.4414 5.96973H11.4424C11.5914 5.83002 11.7906 5.7501 12 5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
